import React from 'react'
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player'

const HomepageVideo = React.forwardRef((props, ref) => {
    return (
        <div className='homepage-video'>
            <ReactPlayer
                url='https://files.exetel.com.au/videos/waving-andy.mp4'
                width='100vw'
                height={props.height}
                onEnded={() => {}}
                loop
                playing
                muted
                config={{
                    file: {
                        attributes: {
                            poster: '/images/poster-andy.jpg'
                        }
                    }
                }}
                ref={ref}
            />
        </div>
    )
})

HomepageVideo.propTypes = {
    height: PropTypes.string
}

HomepageVideo.defaultProps = {
    height: 'calc(100vh - 60px)'
}

export default HomepageVideo



// WEBPACK FOOTER //
// ./resources/js/modules/HomepageVideo.js